document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for Slick to fully initialize
  setTimeout(function() {
    if (typeof jQuery !== 'undefined') {
      initializeAccessibilityManagement();
    }
  }, 1000);
});

function initializeAccessibilityManagement() {
  jQuery(function($) {
    // Function to manage focusable elements in slides
    function manageFocusableElements() {
      $('.testi-inner-wrapper .slick-slide').each(function() {
        var $slide = $(this);
        var isHidden = $slide.attr('aria-hidden') === 'true';
        var $focusableElements = $slide.find('.testimon-text, .testi-author-name');
        
        if (isHidden) {
          // Store original tabindex and remove from tab order
          $focusableElements.each(function() {
            var $el = $(this);
            if (!$el.data('original-tabindex')) {
              $el.data('original-tabindex', $el.attr('tabindex') || '0');
            }
            $el.attr('tabindex', '-1');
          });
        } else {
          // Restore original tabindex for visible slides
          $focusableElements.each(function() {
            var $el = $(this);
            var originalTabindex = $el.data('original-tabindex') || '0';
            $el.attr('tabindex', originalTabindex);
          });
        }
      });
    }

    // Initial run
    manageFocusableElements();

    // Run after slide changes
    $('.testi-inner-wrapper').on('afterChange.accessibility', function(event, slick, currentSlide) {
      manageFocusableElements();
    });

    // Run when slides are repositioned
    $('.testi-inner-wrapper').on('setPosition.accessibility', function(event, slick) {
      setTimeout(manageFocusableElements, 100);
    });

    // Also run on window resize (in case responsive settings change)
    $(window).on('resize.testimonial', function() {
      setTimeout(manageFocusableElements, 200);
    });
  });
}